import styled from 'styled-components';
import { Title } from 'bloomer/lib/elements/Title';

const MarginlessTitle = styled(Title)<any>`
  &.title:not(:last-child) {
    margin: 0;
  }
`;

export default MarginlessTitle;
